import store from "store/store";
import { getIsWhiteLabel } from "store/whiteLabel/selectors";
import { featureFlag } from "services/featureFlag";

// есть ещё front-app/src/services/analytics.js для amplitude которая на данный момент не используется
// почему не сделан один единсткеный сервиси для аналитики:
/*
Edgar Abgaryan, [19 Jun 2025 at 15:08:10]:
ga4 и amplitude это не взаимозаменяемые сущности?

Евгений Саламантов, [19 Jun 2025 at 15:08:20]:
нет
ga - marketing- там всего несколько ивентов
amplitude - продуктовая аналитика, отвечает на разные вопросы, а сколько из тек кто сделал триал создали емейлы в этом месяце, или любой другой подобного рода

Edgar Abgaryan, [19 Jun 2025 at 15:09:49]:
и там и там кастомные ивенты

Евгений Саламантов, [19 Jun 2025 at 15:10:27]:
но инструменты внутри платформ сильно разные
 */


export const marketingAnalytics = {
  fireEvent: (eventName: string) => {
    if (!featureFlag.marketingAnalysis) return;
    const isWhiteLabel = getIsWhiteLabel(store.getState());
    if (isWhiteLabel) return;

    window.gtag("event", eventName);
  },
} as const;
